import { actionTypes } from '../constants'

export const sortControlWasClicked = () => ({
  type: actionTypes.SORT_CONTROL_WAS_CLICKED,
})
